export default __webpack_public_path__ + "static/media/25.d57ed5c7.jpg";